<template>
    <select-menu v-model="local"
                 :text="text"
                 :values="values">
        <slot></slot>
    </select-menu>
</template>

<script>
import SelectMenu from "../UI/SelectMenu.vue";

export default {
    name: "UserGroupFilter",

    components: {SelectMenu},

    props: {
        value: {},
        filter: {
            default: false,
        },
    },

    inject: ['group'],

    computed: {
        text() {
            return ['Bitte wählen'].concat(this.group.user_groups.map(g => g.name));
        },
        values() {
            return [''].concat(this.group.user_groups.map(g => g.id));
        },
        local: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            },
        },
    }
}
</script>

<style scoped>

</style>
